module.exports = __webpack_public_path__ + "static/media/call14.bb259114.gif";